export function getDeviceName(): string {
  const ua = navigator.userAgent;

  let device = "Unknown Device";
  let browser = "Unknown Browser";

  // Detect device
  if (/Windows/i.test(ua)) device = "Windows PC";
  else if (/Mac/i.test(ua)) device = "Mac";
  else if (/iPhone/i.test(ua)) device = "iPhone";
  else if (/iPad/i.test(ua)) device = "iPad";
  else if (/Android/i.test(ua)) device = "Android Device";

  // Detect browser
  if (/Chrome/i.test(ua)) browser = "Chrome";
  else if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) browser = "Safari";
  else if (/Firefox/i.test(ua)) browser = "Firefox";
  else if (/Edge/i.test(ua)) browser = "Edge";

  return `${device} – ${browser}`;
}